module.exports = __webpack_public_path__ + "img/img_safety_img4.8ec5c9af.png";